import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

if (typeof document !== 'undefined') {
  document.documentElement.lang = 'en-GB';
}

const HOTJAR_ID = import.meta.env.VITE_HOTJAR_ID as string | undefined;
const HOTJAR_SNIPPET_VERSION = Number.parseInt((import.meta.env.VITE_HOTJAR_SV as string | undefined) ?? '6', 10);
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
const CONTENTSQUARE_TAG_ID = import.meta.env.VITE_CONTENTSQUARE_TAG_ID as string | undefined;
const AHREFS_ANALYTICS_KEY = import.meta.env.VITE_AHREFS_ANALYTICS_KEY as string | undefined;

if (typeof window !== 'undefined') {
  window.__TRD_ANALYTICS__ = {
    gaMeasurementId: GA_MEASUREMENT_ID?.trim() ?? '',
    contentSquareTagId: CONTENTSQUARE_TAG_ID?.trim() ?? '',
    ahrefsAnalyticsKey: AHREFS_ANALYTICS_KEY?.trim() ?? '',
  };
}

if (typeof window !== 'undefined' && HOTJAR_ID && !window.hj) {
  const hotjarId = Number.parseInt(HOTJAR_ID, 10);
  const hotjarSv = Number.isFinite(HOTJAR_SNIPPET_VERSION) ? HOTJAR_SNIPPET_VERSION : 6;

  if (Number.isFinite(hotjarId)) {
    ((h: Window, o: Document, t: string, j: string, a?: HTMLScriptElement, r?: HTMLHeadElement) => {
      h.hj = h.hj || ((...args: unknown[]) => {
        (h.hj as { q?: unknown[][] }).q = (h.hj as { q?: unknown[][] }).q || [];
        (h.hj as { q?: unknown[][] }).q?.push(args);
      });
      h._hjSettings = { hjid: hotjarId, hjsv: hotjarSv };
      a = o.createElement('script');
      a.async = true;
      a.src = `${t}${h._hjSettings.hjid}${j}${h._hjSettings.hjsv}`;
      r = o.getElementsByTagName('head')[0];
      r.appendChild(a);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }
}

createRoot(document.getElementById('root')!).render(<App />);
